import type { UserRole } from "../types.js";

/**
 * Decisão pura do guard de papel (decisão 5 do WEBUI-PLAN.md). Separada do
 * componente RequireRole para ser testável em node, sem React/DOM/Firebase.
 * Acesso permitido apenas quando há usuário e o papel bate com o exigido.
 */
export function isRoleAllowed(
  role: UserRole | null | undefined,
  required: UserRole
): boolean {
  return role !== null && role !== undefined && role === required;
}
